import { LinkTarget } from 'types/navigation.js';
import { ComponentLink } from './link/link-component.js';

type IModuleAdvert = {
  image?: string;
  url?: string;
};

/** Used when ads are appended to module */
export const SponsorAppend2Module = (props: IModuleAdvert) => {
  const { image, url } = props;
  if (image) {
    return (
      <div data-component="advert-module" className="Tile-body Tile-body--noPadding">
        <ComponentLink url={url} target={LinkTarget.BLANK} urlClasses="u-block">
          <img
            src={image}
            className="u-block"
            width="100%"
            onError={(e) => {
              e.currentTarget.style.height = '0';
              e.currentTarget.style.visibility = 'hidden';
            }}
          />
        </ComponentLink>
      </div>
    );
  }
  return null;
};
